import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchContactFormSubmissions } from '../services/api'; // Use your API file

export const getContactFormSubmissions = createAsyncThunk('contactFormSubmissions/getContactFormSubmissions', async (contact) => {
    const response = await fetchContactFormSubmissions(contact); // Pass contact if available
    return response.data;
});

const contactFormSubmissionSlice = createSlice({
    name: 'contactFormSubmissions',
    initialState: {
        contactFormSubmissions: [],  // Storing open calls here
        status: 'idle',
        error: null,
    },
    reducers: {},
    extraReducers: {
        [getContactFormSubmissions.pending]: (state) => {
            state.status = 'loading';
        },
        [getContactFormSubmissions.fulfilled]: (state, action) => {
            state.contactFormSubmissions = action.payload.data;
            state.status = 'succeeded';
        },
        [getContactFormSubmissions.rejected]: (state, action) => {
            state.status = 'failed';
            state.error = action.error.message;
        },
    },
});

export default contactFormSubmissionSlice.reducer;